<template>
    <p class="student-code" @click.prevent="onCode">
        {{ $t('profile.student_code') }}:
        <span class="student-code__code">{{ code }}</span>
        <v-icon>mdi-content-copy</v-icon>
    </p>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'student-code',
    props: {
        code: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions('snackbar', [
            'setSnackbarMessage'
        ]),
        async onCode() {
            await navigator.clipboard.writeText(this.code)
            this.setSnackbarMessage({ content: this.$t('profile.student_code_message'), color: 'success' })
        }
    }
}
</script>

<style lang="scss" scoped>
.student-code {
    align-items: center;
    background: #FFFFFF80;
    border-radius: 4px;
    color:#64748B;
    cursor: pointer;
    display: initial;
    font-weight: 400;
    justify-content: center;
    max-width: 30px;
    padding: 6px 8px;
    white-space: nowrap;
    width: auto;

    &__code {
        background-color: #FFFFFFE5;
        border-radius: 4px;
        color: #323A46;
        font-weight: 600;
        margin: 0 6px;
        padding: 0 6px;
    }

    @media (min-width: 600px) {
        max-width: 510px;
    }
}
</style>
